export const SHARE_UTM_MEDIUM = 'share';
